import createModule from "../createModule"
import { getIsOpPro } from "modules/account-root/selectors"
import { getEzeConnected, getEzePortfolios, getImporting, getResourceLimits } from "./selectors"
import { Creators } from "./model"
import view from "./view"

export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "ezeMetadata",
    url: ({ account }) => {
      if (!account) {
        return null
      }
      return ({
        id: `ezeMetadata-${account}`,
        url: `/api/${account}/partners/meta?partnerType=eze`,
      })
    },
  }, {
    resource: "ezePortfolios",
    passthrough: true,
    url: ({ account }) => {
      if (!account) {
        return null
      }

      return ({
        id: `ezePortfolios-${account}`,
        url: `/api/${account}/eze/portfolios`,
      })
    },
  }],
  mapStateToProps: (state) => ({
    connected: getEzeConnected(state),
    portfolios: getEzePortfolios(state),
    importing: getImporting(state),
    resourceLimits: getResourceLimits(state),
    isOpPro: getIsOpPro(state),
  }),
  actions: {
    ...Creators,
  },
})
